import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
@Component({
  selector: "covid-screening",
  templateUrl: "covid-screening.html",
})
export class CovidScreening implements OnInit {
  @Input() config;
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean = false;

  label: string;
  layout: any;
  inputs: any;
  radioInputs: any;
  formGroup: FormGroup;
  access: string;
  cardData: any;
  initialized: boolean = false;

  constructor(private formBuilder: FormBuilder) {}

  public ngOnInit(): void {
    this.layout = this.config.layout;
    this.label = this.config.cardName;
    this.access = this.config.access;
    this.inputs = Object.values(this.config.inputs).sort((a: any, b: any) => {
      return a.sortOrder - b.sortOrder;
    });
    this.radioInputs = this.inputs.filter((i) => i.type === "radio");
    this.formGroup = this.formBuilder.group({});
    for (let key of this.inputs) {
      this.formGroup.addControl(
        key.componentId,
        this.formBuilder.control(undefined)
      );
    }
    this.formGroup.valueChanges.subscribe((data) => {
      if (!this.disabled) {
        this.cardData = data;
        this.onDataUpdate.emit({ cardId: this.config.id, value: data });
      } else {
        this.onDataUpdate.emit({ cardId: this.config.id, value: {} });
      }
    });
  }
  public clear(toClear): void {
    const radioAndTextInput = [toClear, toClear + "Text"];
    radioAndTextInput.forEach((item) => {
      this.formGroup.get(item).setValue(null);
      this.formGroup.get(item).clearValidators();
      this.formGroup.get(item).updateValueAndValidity();
    });
  }

  @Input() set data(incomingData: any) {
    this.cardData = incomingData;
    if (incomingData && incomingData.data && incomingData.data[0]) {
      const data = incomingData.data[0];
      for (let key of Object.keys(data)) {
        if (this.formGroup.controls[key]) {
          this.formGroup.controls[key].setValue(data[key]);
        }
      }
    }
    if (incomingData !== undefined && !this.initialized) {
      this.initialized = true;
      this.onCardInitialized.emit(this.config.id);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && this.formGroup) {
      this.disabled ? this.formGroup.disable() : this.formGroup.enable();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/covid-screening/covid-screening.ts